import { Link } from 'react-router-dom';
import { useState } from 'react';
import { FaBars, FaX } from 'react-icons/fa6';


export default function GlobalNavbar() {
    const [navVisible, setNavVisible] = useState(false)

    function NavBars() {
        return (
            <div
                onClick={() => setNavVisible(!navVisible)}
                className="cursor-pointer pr-4 z-10"
            >
                {navVisible ? <FaX size={30} />: <FaBars size={30} />}
            </div>
        )
    }

    const navLinks = [
        {
            id: 1,
            name: 'Portfolio',
            link: '/',
        },
        {
            id: 2,
            name: 'Blog',
            link: '/blog',
        },
        {
            id: 3,
            name: 'Services',
            link: '/services',
        },
    ]

  return (
    <nav>
        <h1 className="text-4xl black-ops-font">Galupi.dev</h1>
        <div className="flex flex-row space-x-4">
            {/* Desktop */}
                {navVisible && <ul className="hidden md:flex space-x-6 pr-3 text-lg black-ops-font"
                >
                    {navLinks.map((link) => (
                        <li key={link.id} className="cursor-pointer">
                            <Link 
                                to={link.link} smooth duration={500}
                                onClick={() => setNavVisible(!navVisible)}
                            >
                                {link.name}
                            </Link>
                        </li>
                    ))}
                </ul>}

            {/* Mobile */}
            {navVisible && 
                <ul className="nav-mobile">
                    {navLinks.map((link) => (
                        <li key={link.id} className="cursor-pointer py-5 text-4xl">
                            <Link 
                                to={link.link} smooth duration={500} 
                                onClick={() => setNavVisible(!navVisible)}
                            >
                                {link.name}
                            </Link>
                        </li>
                    ))}
                </ul>
            }
            <NavBars />
        </div>
    </nav>
  )
}
